import { Button } from '@/components/ui/button'

export function DemoShadcn() {
  return (
    <div className="min-h-screen bg-background p-8 flex flex-col gap-4 items-center justify-center">
      <h1 className="text-2xl font-semibold text-foreground mb-4">
        shadcn Demo (Tailwind aktiv)
      </h1>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button>Default Button</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="outline">Outline</Button>
        <Button variant="destructive">Destructive</Button>
        <Button variant="ghost">Ghost</Button>
      </div>

      <p className="text-sm text-muted-foreground mt-8 text-center max-w-xs">
        Wenn diese Buttons rund, iOS-mäßig und im richtigen Theme erscheinen,
        ist Tailwind + shadcn korrekt eingerichtet.
      </p>
    </div>
  )
}
